import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoadingController } from 'ionic-angular';

/*
  Generated class for the LoadingProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LoadingProvider {

  public loader

  constructor(private loading: LoadingController) {
   
  }

  presentLoading(message){
    this.loader = this.loading.create({
      content:message
    })
    this.loader.present();
  }

}



// WEBPACK FOOTER //
// ./src/providers/loading/loading.ts